import { format as dateFormat } from 'date-fns';

export function formatDate(date: Date | string | number | null | undefined, format = 'dd/MM/yyyy'): string {
  if (!date) return '';

  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [yyyy, MM, dd] = date.split('-') as [string, string, string];

    return `${dd}/${MM}/${yyyy}`;
  }

  // 2) Date | number handling
  const parsedDate = date instanceof Date ? date : new Date(date);
  if (isNaN(parsedDate.getTime())) return '';

  // If this moment is exactly UTC midnight, treat as date-only using UTC parts
  const isUtcMidnight =
    parsedDate.getUTCHours() === 0 &&
    parsedDate.getUTCMinutes() === 0 &&
    parsedDate.getUTCSeconds() === 0 &&
    parsedDate.getUTCMilliseconds() === 0;

  if (isUtcMidnight) {
    const dd = String(parsedDate.getUTCDate()).padStart(2, '0');
    const MM = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
    const yyyy = String(parsedDate.getUTCFullYear());

    return `${dd}/${MM}/${yyyy}`;
  }

  // Fallback to provided formatter (likely date-fns/format) in local time
  return dateFormat(parsedDate, format);
}

export function formatDateForBackend(date: Date | string | null) {
  if (!date) {
    return null;
  }

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  return dateFormat(parsedDate, 'yyyy-MM-dd');
}

export const getDateIncreasedByDays = (days?: number) => {
  if (!Number.isFinite(days)) {
    return;
  }

  const date = new Date();
  date.setDate(date.getDate() + days!);

  return date;
};

export const getDateDecreasedByDays = (days?: number) => {
  if (!Number.isFinite(days)) {
    return;
  }

  const date = new Date();
  date.setDate(date.getDate() - days!);

  return date;
};
